const isFavourite = (favourites, project) => {
  if (project && project.id) {
    return favourites.ids.includes(project.id.toString())
  }
  return false
}

const printUrl = (locale, slug) => `${projectPath(locale, slug)}/print`

const projectComplete = (url) => {
  const match = url.match(/..\/projects\/.+\/complete\/?$/i)
  return Boolean(match)
}

const projectPath = (locale, slug) => `/${locale}/projects/${slug}`

const themeClassName = (theme) => {
  const themeClass = [
    'red',
    'green',
    'turquoise',
    'orange',
    'yellow',
    'violet',
    'navy',
    'blue',
    'cyan',
    'pink',
    'lilac',
  ].includes(theme)
    ? theme
    : 'red'

  return `theme-${themeClass}`
}
const transitionName = (slideDirection) => {
  return `c-project-steps__wrapper--animate-${slideDirection}`
}

const getPathwayDetails = (included) => {
  const linkedPathways = included?.pathways || []
  const betaPathways = linkedPathways.filter(
    (linkedPathway) => linkedPathway.isBeta === true
  )
  return betaPathways && betaPathways.length ? betaPathways[0] : {}
}

export {
  isFavourite,
  printUrl,
  projectComplete,
  projectPath,
  themeClassName,
  transitionName,
  getPathwayDetails,
}
